<template>
  <div class="Main-Inner" id="AccountLayout">
    <div class="Main-Sidebar-Wrapper">
      <div class="Main-Sidebar">
        <ul class="nav" id="dashboard-nav">

          <div :class="personalClass">
            <li class="section list-heading" @click="togglePersonal">
              {{$t('Personal')}}<Icon class="arrow-icon" :icon="personalIsOpen ? 'fas fa-angle-down' : 'fas fa-angle-up'"/>  
            </li>
            <div class="links">
              <template v-if="theUser.accountId === theUser.onBehalfOfAccountId">
                <router-link ref="profileLink" tag="li" :to="{ path: '/account/profile/' }" active-class="active"><a class="nav-link">{{$t('Profile')}}</a></router-link>
                <router-link ref="changePasswordLink" tag="li" :to="{ path: '/account/changePassword/' }" active-class="active"><a class="nav-link">{{$t('Change Password')}}</a></router-link>
              </template>
              <template v-else>
                <li>
                  <Tooltip content="Cannot access as an agency">
                    <a class="nav-link">{{$t('Profile')}}</a>
                  </Tooltip></li>
                <li>
                  <Tooltip content="Cannot access as an agency">
                    <a class="nav-link">{{$t('Change Password')}}</a>
                  </Tooltip>
                </li>
              </template>
            </div>
          </div>

          <div :class="accountClass">
            <li class="section list-heading" @click="toggleAccount">
              {{$t('Account')}}<Icon class="arrow-icon" :icon="accountIsOpen ? 'fas fa-angle-down' : 'fas fa-angle-up'"/>
            </li>
            <div class="links">
              <router-link ref="companyLink" tag="li" :to="{ path: '/account/company/' }" active-class="active"><a class="nav-link">{{$t('Company')}}</a></router-link>
              <router-link v-if="theUser.isAdmin" ref="usersLink" tag="li" :to="{ path: '/account/users/' }" active-class="active"><a class="nav-link">{{$t('Users')}}</a></router-link>
              <router-link v-if="theUser.isAdmin || theUser.isAgency" ref="agencyLink" tag="li" :to="{ path: '/account/agency/' }" active-class="active"><a class="nav-link">{{$t('Agency')}}</a></router-link>
              <router-link tag="li" ref="preferencesLink" :to="{ path: '/account/preferences/' }" active-class="active"><a class="nav-link">{{$t('Preferences')}}</a></router-link>
              <router-link v-if="theUser.isAdmin" tag="li" ref="securityLink" :to="{ path: '/account/security/' }" active-class="active"><a class="nav-link">{{$t('Security')}}</a></router-link>
            </div>
          </div>

          <div :class="storeClass">
            <li class="section list-heading" @click="toggleStore">
              {{$t('Store')}}<Icon class="arrow-icon" :icon="storeIsOpen ? 'fas fa-angle-down' : 'fas fa-angle-up'"/>
            </li>
            <div class="links">
              <router-link ref="shopLinksLink" tag="li" :to="{ path: '/account/shopLinks/' }" active-class="active"><a class="nav-link">{{$t('Linked Store')}}</a></router-link>
              <router-link ref="domainsLink" tag="li" :to="{ path: '/account/domains/' }" active-class="active"><a class="nav-link">{{$t('Domains')}}</a></router-link>
            </div>
          </div>

          <div :class="billingClass" v-if="theUser.hasInvoiceAccess || theUser.hasTransactionAccess">
            <li class="section list-heading" @click="toggleBilling">
              {{$t('Billing')}}<Icon class="arrow-icon" :icon="billingIsOpen ? 'fas fa-angle-down' : 'fas fa-angle-up'"/>
            </li>
            <div class="links">
              <router-link v-if="theUser.hasTransactionAccess" ref="transactionsLink" tag="li" :to="{ path: '/account/transactions/' }" active-class="active"><a class="nav-link">{{$t('Transactions')}}</a></router-link>
              <router-link v-if="theUser.hasTransactionAccess" ref="conversionsLink" tag="li" :to="{ path: '/account/conversions/' }" active-class="active"><a class="nav-link">{{$t('Conversions')}}</a></router-link>
              <router-link v-if="theUser.hasConversionDefinitionAccess" ref="conversionDefinitionsLink" tag="li" :to="{ path: '/account/conversion-definitions/' }" active-class="active"><a class="nav-link">{{$t('Conversion Definitions')}}</a></router-link>
              <router-link v-if="theUser.hasInvoiceAccess" ref="invoicesLink" tag="li" :to="{ path: '/account/invoices/' }" active-class="active"><a class="nav-link">{{$t('Invoices')}}</a></router-link>
            </div>
          </div>

          <div :class="streamingClass">
            <li class="section list-heading" @click="toggleStreaming">
              {{$t('Streaming')}}<Icon class="arrow-icon" :icon="streamingIsOpen ? 'fas fa-angle-down' : 'fas fa-angle-up'"/>
            </li>
            <div class="links">
              <router-link ref="endpointsLink" tag="li" :to="{ path: '/account/endpoints/' }" active-class="active"><a class="nav-link">{{$t('Endpoints')}}</a></router-link>
              <router-link ref="streamsLink" tag="li" :to="{ path: '/account/streams/' }" active-class="active"><a class="nav-link">{{$t('Streams')}}</a></router-link>
            </div>
          </div>

          <div :class="otherClass">
            <li class="section list-heading" @click="toggleOther">
              {{$t('Other')}}<Icon class="arrow-icon" :icon="otherIsOpen ? 'fas fa-angle-down' : 'fas fa-angle-up'"/>
            </li>
            <div class="links">
              <router-link
                v-if="theUser.recommendationsEnabled && theUser.hasRecommendationsAccess"
                ref="recCatalogLink"
                tag="li"
                :to="{ path: '/account/productRecCatalog/' }"
                active-class="active"
              ><a class="nav-link">{{$t('Recommendations')}}</a></router-link>
              <router-link ref="customDataLink" tag="li" :to="{ path: '/account/customData/' }" active-class="active"><a class="nav-link">{{$t('Custom Data')}}</a></router-link>
              <router-link ref="formResponsesLink" tag="li" :to="{ path: '/account/formResponses/' }" active-class="active"><a class="nav-link">{{$t('Form Responses')}}</a></router-link>
              <router-link ref="exportEmailsLink" tag="li" :to="{ path: '/account/exportEmails/' }" active-class="active"><a class="nav-link">{{$t('Export Emails')}}</a></router-link>
              <router-link ref="sharedRulesetsLink" tag="li" :to="{ path: '/account/sharedRulesets/' }" active-class="active"><a class="nav-link">{{$t('Shared Rulesets')}}</a></router-link>
              <router-link ref="summaryEmailsLink" tag="li" :to="{ path: '/account/summaryEmails/' }" active-class="active"><a class="nav-link">{{$t('Summary Emails')}}</a></router-link>
              <router-link ref="downloadsLink" tag="li" :to="{ path: '/account/downloads/' }" active-class="active"><a class="nav-link">{{$t('Downloads')}}</a></router-link>
              <router-link v-if="theUser.isSuper" ref="scheduledReportsLink" tag="li" :to="{ path: '/account/scheduledReports/' }" active-class="active"><a class="nav-link">{{$t('Scheduled Reports')}}</a></router-link>
            </div>
          </div>
        </ul>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'AccountLayout',
  data() {
    return {
      personalIsOpen: false,
      accountIsOpen: false,
      storeIsOpen: false,
      billingIsOpen: false,
      streamingIsOpen: false,
      otherIsOpen: false
    }
  },
  mounted() {
    this.accordionWatcher()
  },
  watch: {
    '$route': function() {
      this.$nextTick(() => {
        this.accordionWatcher()
      })
    }
  },
  methods: {
    accordionWatcher() {
      if (this.$refs.profileLink && this.$refs.profileLink.$el.classList.contains('active')) this.togglePersonal()
      if (this.$refs.changePasswordLink && this.$refs.changePasswordLink.$el.classList.contains('active')) this.togglePersonal()
      if (this.$refs.companyLink && this.$refs.companyLink.$el.classList.contains('active')) this.toggleAccount()
      if (this.$refs.usersLink && this.$refs.usersLink.$el.classList.contains('active')) this.toggleAccount()
      if (this.$refs.agencyLink && this.$refs.agencyLink.$el.classList.contains('active')) this.toggleAccount()
      if (this.$refs.preferencesLink && this.$refs.preferencesLink.$el.classList.contains('active')) this.toggleAccount()
      if (this.$refs.securityLink && this.$refs.securityLink.$el.classList.contains('active')) this.toggleAccount()
      if (this.$refs.shopLinksLink && this.$refs.shopLinksLink.$el.classList.contains('active')) this.toggleStore()
      if (this.$refs.domainsLink && this.$refs.domainsLink.$el.classList.contains('active')) this.toggleStore()
      if (this.$refs.transactionsLink && this.$refs.transactionsLink.$el.classList.contains('active')) this.toggleBilling()
      if (this.$refs.conversionsLink && this.$refs.conversionsLink.$el.classList.contains('active')) this.toggleBilling()
      if (this.$refs.conversionDefinitionsLink && this.$refs.conversionDefinitionsLink.$el.classList.contains('active')) this.toggleBilling()
      if (this.$refs.invoicesLink && this.$refs.invoicesLink.$el.classList.contains('active')) this.toggleBilling()
      if (this.$refs.endpointsLink && this.$refs.endpointsLink.$el.classList.contains('active')) this.toggleStreaming()
      if (this.$refs.streamsLink && this.$refs.streamsLink.$el.classList.contains('active')) this.toggleStreaming()
      if (this.$refs.recCatalogLink && this.$refs.recCatalogLink.$el.classList.contains('active')) this.toggleOther()
      if (this.$refs.customDataLink && this.$refs.customDataLink.$el.classList.contains('active')) this.toggleOther()
      if (this.$refs.formResponsesLink && this.$refs.formResponsesLink.$el.classList.contains('active')) this.toggleOther()
      if (this.$refs.exportEmailsLink && this.$refs.exportEmailsLink.$el.classList.contains('active')) this.toggleOther()
      if (this.$refs.sharedRulesetsLink && this.$refs.sharedRulesetsLink.$el.classList.contains('active')) this.toggleOther()
      if (this.$refs.summaryEmailsLink && this.$refs.summaryEmailsLink.$el.classList.contains('active')) this.toggleOther()
      if (this.$refs.downloadsLink && this.$refs.downloadsLink.$el.classList.contains('active')) this.toggleOther()
      if (this.$refs.scheduledReportsLink && this.$refs.scheduledReportsLink.$el.classList.contains('active')) this.toggleOther()
    },
    togglePersonal() {
      this.personalIsOpen = true
      this.accountIsOpen = false
      this.storeIsOpen = false
      this.billingIsOpen = false
      this.streamingIsOpen = false
      this.otherIsOpen = false
    },
    toggleAccount() {
      this.accountIsOpen = true
      this.personalIsOpen = false
      this.storeIsOpen = false
      this.billingIsOpen = false
      this.streamingIsOpen = false
      this.otherIsOpen = false
    },
    toggleStore() {
      this.storeIsOpen = true
      this.personalIsOpen = false
      this.accountIsOpen = false
      this.billingIsOpen = false
      this.streamingIsOpen = false
      this.otherIsOpen = false
    },
    toggleBilling() {
      this.billingIsOpen = true
      this.personalIsOpen = false
      this.accountIsOpen = false
      this.storeIsOpen = false
      this.streamingIsOpen = false
      this.otherIsOpen = false
    },
    toggleStreaming() {
      this.streamingIsOpen = true
      this.personalIsOpen = false
      this.accountIsOpen = false
      this.storeIsOpen = false
      this.billingIsOpen = false
      this.otherIsOpen = false
    },
    toggleOther() {
      this.otherIsOpen = true
      this.personalIsOpen = false
      this.accountIsOpen = false
      this.storeIsOpen = false
      this.billingIsOpen = false
      this.streamingIsOpen = false
    },
    closeAll() {
      this.personalIsOpen = false
      this.accountIsOpen = false
      this.storeIsOpen = false
      this.billingIsOpen = false
      this.streamingIsOpen = false
      this.otherIsOpen = false
    }
  },
  computed: {
    personalClass() {
      return {
        'is-closed': !this.personalIsOpen
      }
    },
    accountClass() {
      return {
        'is-closed': !this.accountIsOpen
      }
    },
    storeClass() {
      return {
        'is-closed': !this.storeIsOpen
      }
    },
    billingClass() {
      return {
        'is-closed': !this.billingIsOpen
      }
    },
    streamingClass() {
      return {
        'is-closed': !this.streamingIsOpen
      }
    },
    otherClass() {
      return {
        'is-closed': !this.otherIsOpen
      }
    }
  }
}
</script>

<style lang="scss">
#AccountLayout {
  .nav > div {
    width: 100%;
  }
  .links {
    transition: 0.3s ease all;
  }
  .list-heading {
    cursor: pointer; 
  }
  .is-closed .links {
    @media screen and (max-height: 1200px) {
      max-height: 0;
      display: none;
    }
  }
  .arrow-icon {
    float: right;
    font-weight: 400;
  }
}
</style>